import type { TOC } from '@ember/component/template-only';

import MetricLibraryComponent from 'webapp/components/metric-library/index';
import type MetricLibraryIndexController from 'webapp/controllers/metric-library/index';

interface Args {
	controller: MetricLibraryIndexController;
}

const MetricLibraryIndexRouteTemplate: TOC<Args> = <template>
	<MetricLibraryComponent
		@onSourceChange={{@controller.sendSourceChange}}
		@onAddMetricsToBoard={{@controller.sendAddMetricsToBoard}}
	/>
</template>;

export default MetricLibraryIndexRouteTemplate;
